module.exports = __webpack_public_path__ + "static/L5Y1s-2d4ab60352ec0d373cf0142af9498e1f.jpg";